import React from 'react';
import { HowToPlayModal } from '../../components/HowToPlayModal/HowToPlayModal';
import './HowToPlayTiles.css';

const EXAMPLES = [
  { letter: 'W', status: 'correct', label: 'In the word and in the correct spot' },
  { letter: 'O', status: 'present', label: 'In the word but in the wrong spot' },
  { letter: 'R', status: 'absent', label: 'Not in the word' },
];

export function HowToPlay({ onClose }) {
  return (
    <HowToPlayModal title="How to Play" titleId="word-master-how-title" onClose={onClose}>
      <p className="how-to-play-intro">
        Guess the <strong>WORD</strong> in 6 tries. Each guess must be a valid 5-letter word.
      </p>
      <p className="how-to-play-intro">
        After each guess, the color of the tiles will change to show how close your guess was:
      </p>

      <div className="how-to-play-examples">
        {EXAMPLES.map(({ letter, status, label }, i) => (
          <div key={status} className="how-to-play-example" style={{ animationDelay: `${i * 0.2}s` }}>
            <div className="how-to-play-tile-demo">
              <div className="tile-flip-card">
                <div className="tile-flip-inner">
                  <div className="tile-flip-front">{letter}</div>
                  <div className={`tile-flip-back ${status}`}>{letter}</div>
                </div>
              </div>
            </div>
            <span className="how-to-play-label">{label}</span>
          </div>
        ))}
      </div>
    </HowToPlayModal>
  );
}
